export default __webpack_public_path__ + "static/media/titel.d746937d.gif";